import request from '@/api/httpRequest2'

// 收藏/取消收藏
export function toggleFavorite(knowledgeId) {
  return request({
    url: `/klgeek/kb/favorite/${knowledgeId}`,
    method: 'post'
  })
}

// 获取收藏列表 
export function getFavoriteList(query) {
  return request({
    url: '/klgeek/kb/favorite/list',
    method: 'get',
    params: query
  })
}

// 检查是否已收藏
export function checkFavorite(knowledgeId) {
  return request({
    url: `/klgeek/kb/favorite/check/${knowledgeId}`,
    method: 'get'
  })
} 